import { ProcessedClause } from "@financial-advisory/data-access/api-types";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { ProcessedClauseApi } from "./decisionProcesses";

interface DecisionProcessesSliceState {
  activeClauseId: string | null;
  activePaneId: string | null;
  data: Record<string, ProcessedClause>;
}

const initialState: DecisionProcessesSliceState = {
  activeClauseId: null,
  activePaneId: null,
  data: {},
};

export const activePaneIdSlice = createSlice({
  name: "activePaneId",
  initialState,
  reducers: {
    setActivePaneId: (state, action: PayloadAction<string | null>) => {
      state.activePaneId = action.payload;
    },
  },
});

export const { setActivePaneId } = activePaneIdSlice.actions;

export const processedClausesSlice = createSlice({
  name: "processedClauses",
  initialState,
  reducers: {
    setActiveClauseById: (state, action: PayloadAction<string | null>) => {
      state.activeClauseId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      ProcessedClauseApi.endpoints.getProcessedClauses.matchFulfilled,
      (state, action) => {
        const response: { data: ProcessedClause[] } = action.payload;
        state.data = response.data.reduce((acc, curr) => {
          return {
            ...acc,
            [curr.id]: curr,
          };
        }, {});
      }
    );
  },
});

export const { setActiveClauseById } = processedClausesSlice.actions;

export const selectClauseById = (id: string) => (state: RootState) => {
  return state.processedClauses.data[id];
};

export const selectActiveClause = (state: RootState) => {
  if (!state.processedClauses.activeClauseId) return undefined;
  const clause =
    state.processedClauses.data[state.processedClauses.activeClauseId];
  return clause;
};

export const selectActivePaneId = (state: RootState) => {
  return state.activePaneId.activePaneId;
};
